<template>
  <div>
    <!-- <headLine></headLine> -->
    <div class="elder_manage_title">
      <p class="title">工单申请管理</p>
    </div>
    <slot name="statistics"></slot>
    <div class="search_wrapper">
      <div class="search_head">
        <span>查询条件</span>
        <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
        <i
          class="searchDomw"
          @click="isSearchContent = !isSearchContent"
          :class="
            isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
          "
        ></i>
      </div>
      <div class="search_content" v-show="isSearchContent">
        <div class="search_inline">
          <el-form
            class="queryForm"
            ref="queryForm"
            :model="queryForm"
            label-width="120px"
          >
            <el-row>
              <el-col :span="5">
                <el-form-item label="姓名：">
                  <el-input
                    clearable
                    v-model="queryForm.customerName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" offset="1">
                <el-button
                  class="searchBtns"
                  type="primary"
                  @click="QuerySearch"
                  >查询
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
      </div>
    </div>
    <!-- <global-tag>
            <span slot="title">工单申请管理</span>
            <div class="search" slot="search">
                 <div>
    <el-form
        class="queryForm"
        ref="queryForm"
        :model="queryForm"
        label-width="120px"
    >
      <el-row>
        <el-col :span="5">
          <el-form-item label="老人姓名：">
            <el-input
                clearable
                v-model="queryForm.customerName"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="QuerySearchBtn">
          <el-button size="medium" type="primary" @click="QuerySearch"
          >查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
            </div>
        </global-tag> -->

    <div style="height: 20px"></div>

    <div style="height: 20px"></div>

    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="老人姓名"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerIdcard"
          label="身份证号码"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="stationName"
          label="机构名称"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="appointmentTime"
          label="预约时间"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="isExist"
          label="是否存在"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isExist == '0'">存在</span>
            <span v-if="scope.row.isExist == '1'">不存在</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerType"
          label="客户类型"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <!-- <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="detailsVisit('查看', scope.row)"
                            >查看</el-button
                        >
                    </template>
                </el-table-column> -->
      </el-table>
    </div>
    <div style="height: 20px"></div>
    <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <!-- <VisitDialog
            ref="visitDialog"
            @updateList="getDataList"
            :show-visit.sync="showVisit"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialog> -->
  </div>
</template>

<script>
import request from "@/utils/request.js"
import globalTag from "../components/globalTag"
import headLine from "../components/headline"
import { metaDataMgrDao } from "@/api/dao.js"

export default {
  components: {
    globalTag,
    headLine,
  },
  data() {
    return {
      queryForm: {
        orderName: "",
        customerType: "",
        serveproductName: "",
        servestationName: "",
        servePersonName: "",
      },
      showVisit: false,
      showTitle: "",
      tableData: [],
      orderInfo: {
        customerName: "",
      },
      totalCount: 0,
      query: {
        pageNum: 1,
        pageSize: 10,
      },
      isSearchContent: true,
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    if (localStorage.getItem("czUserInfo")) {
      var dataId = JSON.parse(localStorage.getItem("czUserInfo")).dataIds
      this.dataId = dataId
      console.log(this.dataId, "asda")
    }
  },
  methods: {
    Reset() {
      this.queryForm = {}
      this.getDataList()
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    getDataList() {
      let params = {
        pageNo: this.query.pageNum,
        pageSize: this.query.pageSize,
        // customerType: this.queryForm.customerType,
        customerName: this.queryForm.customerName,
      }
      request({
        url: "/jjyl/admin/servicePgdApply/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === "1") {
        return "一星"
      } else if (row.estimateLevel === "2") {
        return "二星"
      } else if (row.estimateLevel === "3") {
        return "三星"
      } else if (row.estimateLevel === "4") {
        return "四星"
      } else if (row.estimateLevel === "5") {
        return "五星"
      }
    },

    getDetails(id) {
      request({
        url: "/jjyl/servicePgd/info/findServicepgdById",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.orderInfo = res.content
          } else {
            this.orderInfo = {}
          }
        }
      })
    },
    QuerySearch() {
      this.getDataList()
    },
    chehui(row) {
      this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgd/info/withdraw",
          method: "POST",
          data: {
            id: row.id,
            states: row.states,
            appStates: row.appStates,
          },
        }).then((res) => {
          if (res.code === 200) {
            this.getDataList()
          }
        })
      })
    },
    handleSelectionChange(val) {},
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.getDataList()
    },
  },
}
</script>

<style lang="less" scoped>
.QuerySearchBtn {
  margin-left: 60px;
}

.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
}

.labelImportBtn {
  margin: 0 10px;

  span {
    width: 70px;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    background-color: #409eff;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
  }
}
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;
  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }
  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw {
  cursor: pointer;
}
</style>
